<ng-container *transloco="let t">
  <!-- Account Manager Selection Button -->
  <button
    type="button"
    class="account-manager__popover-btn btn btn-outline-primary bg-white text-primary"
    #popover="bs-popover"
    [popover]="accountManagerPopoverContent"
    placement="bottom"
    [adaptivePosition]="false"
    [outsideClick]="true"
    [attr.aria-label]="t('sellModule.manageInventory.manageHeader.labelAccountManager') + ' (' + totalSelected + t('common.of') + maxSelectedItems + ')'"
    aria-haspopup="dialog"
    [attr.aria-expanded]="popover.isOpen"
    data-test-id="app-account-manager-e-account-manager-button"
    (onShown)="onShown()"
    (onHidden)="applyAndSearch()">

    <span class="account-manager__popover-btn-text">{{ t('sellModule.manageInventory.manageHeader.labelAccountManager') }}</span>
    <span class="ms-1 me-1 pe-1">({{ totalSelected }} {{ t('common.of') }} {{ maxSelectedItems }})</span>
    <i
      class="ms-auto allycon-glyph-chevron-down text-primary"
      aria-hidden="true">
    </i>
  </button>

  <!-- Account Manager Popover Content -->
  <ng-template #accountManagerPopoverContent>
    <div class="account-manager__popover" role="dialog">
      <div class="account-manager__popover-content">

        @if (accountManagers?.length > 10) {
          <!-- Search Input -->
          <div class="form-group mb-3">
            <label
              for="account-manager-search"
              class="text-uppercase d-block">
              {{ t('common.labelSearch') }}
            </label>
            <div class="search-input-container">
              <input
                id="account-manager-search"
                type="text"
                class="form-control"
                [placeholder]="''"
                data-test-id="app-account-manager-popover-e-search-phrase-text-input"
                [(ngModel)]="searchTerm$"
                (input)="search($event)" />
              @if (searchTerm$()) {
                <button
                  type="button"
                  class="search-input-clear"
                  [attr.aria-label]="t('common.altClearSearchInput')"
                  (click)="clearSearch($event)"
                  data-test-id="app-account-manager-popover-e-clear-search-button">
                  <img
                    src="../../../../ui/assets/assets-{{ tenantName$() }}/{{ tenantName$() }}-close.svg"
                    [alt]="t('common.altClearSearchInput')" />
                </button>
              }
            </div>
          </div>
        }

        <!-- Selected Account Managers -->
        @if (sortedSelectedAccountManagers.length > 0) {
          <div class="material-checkbox mb-3" role="group">
            @for (accountManager of sortedSelectedAccountManagers$(); track accountManager.userUuid) {
              <div class="account-manager-item">
                <mat-checkbox
                  [checked]="true"
                  [disableRipple]="true"
                  (click)="onCheckboxClick($event, accountManager)"
                  [attr.data-test-id]="'app-account-manager-selected-checkbox-' + accountManager.userUuid"
                  [aria-label]="accountManager.userName">
                  {{ accountManager.userName }}
                </mat-checkbox>
              </div>
            }
          </div>
          <div class="search-results-divider"></div>
        }

        <!-- Account Manager List -->
        <div class="material-checkbox" role="group">
          @for (accountManager of visibleAccountManagers$(); track accountManager.userUuid) {
            <div class="account-manager-item">
              <mat-checkbox
                [checked]="isAccountManagerSelected(accountManager)"
                [disableRipple]="true"
                [disabled]="isMaxSelectionReached && !isAccountManagerSelected(accountManager)"
                (click)="onCheckboxClick($event, accountManager)"
                [attr.data-test-id]="'app-account-manager-checkbox-' + accountManager.userUuid"
                [aria-label]="accountManager.userName">
                {{ accountManager.userName }}
              </mat-checkbox>
            </div>
          }

          <!-- Show More / Show Less Button -->
          @if (shouldShowToggleButton) {
            @if (hasMoreItems) {
              <button
                type="button"
                class="btn btn-link p-0 mt-2 show-more-btn"
                (click)="showMore($event)"
                data-test-id="app-account-manager-show-more-btn">
                {{ t('common.btnShowMore') }}
              </button>
            } @else if (canShowLess) {
              <button
                type="button"
                class="btn btn-link p-0 mt-2 show-less-btn"
                (click)="showLess($event)"
                data-test-id="app-account-manager-show-less-btn">
                {{ t('common.btnShowLess') }}
              </button>
            }
          }
        </div>

      </div>

      <!-- Apply Button -->
      <button
        type="button"
        class="btn btn-outline-primary btn-block mt-3"
        data-track-elem="button"
        data-track-name="account-manager - apply"
        data-track-trigger="apply"
        data-test-id="app-account-manager-e-apply-button"
        (click)="applyAndSearch()">
        {{ t('common.btnApply') }}
      </button>
    </div>
  </ng-template>
</ng-container>
